export default "__VITE_ASSET__CAvRh5z8__"